import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Utils
// Constants
import { API_URL } from '@src/shared/src/const/api';
import { STATUS } from '@src/shared/src/const/app';

// Actions
// Models
import { DocumentModel } from '@src/shared/src/models';
// Interfaces
// Components
// Styles
import '../styles/ConfirmedBookingDocuments.scss';
import { Link } from '@toolkit/ui';

type Props = {
  documents: DocumentModel[];
  basketStatus: string;
};

const ConfirmedBookingDocuments: React.FC<Props> = (props) => {
  const { documents, basketStatus } = props;
  const { t } = useTranslation();

  if (basketStatus !== STATUS.CONFIRM_FINISHED || documents.length === 0 || (window as any).__IS_WEBVIEW) {
    return null;
  }

  return (
    <div className="confirmed-booking-documents">
      <h2 className="confirmed-booking-documents-title">{t('BookingDocuments.title')}</h2>
      {documents.map((document: DocumentModel) => (
        <div className="confirmed-booking-documents-item" key={`document-${document.id}`}>
          <div>
            {document.category && (
              <div className="confirmed-booking-documents-item-title">
                {t(`BookingDocuments.${document.category}`)}
              </div>
            )}
            <div className="confirmed-booking-documents-item-subtitle">{document.name}</div>
          </div>
          <Link
            icon={<i className="material-symbols">download</i>}
            href={`${API_URL.DOCUMENTS}/${document.id}/download`}>
            {t('BookingDocuments.download')}
          </Link>
        </div>
      ))}
    </div>
  );
};

export default ConfirmedBookingDocuments;
